var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "topbar-content as-flex main-start cross-center" },
    [
      _c("div", { staticClass: "tab-page-container" }, [_c("tabpage")], 1),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          staticClass: "userinfo-container",
          attrs: {
            "popper-class": "userinfoBox",
            placement: "bottom-start",
            trigger: "hover",
          },
        },
        [
          _c(
            "div",
            { staticClass: "as-full-height as-full-width" },
            [_c("userInfoBox", { attrs: { userInfo: _vm.userInfo } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "as-full-width as-full-height as-flex main-end cross-center",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c("span", { staticClass: "profile-name f-2" }, [
                _vm._v(_vm._s(_vm.userInfo ? _vm.userInfo.company : "--")),
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "profile-img",
                attrs: {
                  src: require("../assets/images/userinfo-profile.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }